export default {
  payment: {
    paymentForm: {
      modal: {
        title: "Платеж"
      },
      form: {
        abcode: "Лицевой счет",
        fullname: "ФИО абонента",
        address: "Адрес проживания",
        dateBegin: "Дата создания",
        dateEnd: "Дата закрытия",
        payTab: {
          title: "Платеж",
          datePay: "Дата оплаты",
          dateBank: "Дата по банку",
          sumPay: "Сумма платежа",
          numPayDoc: "Номер платежного документа",
          methodPay: "Способ оплаты",
          orgPay: "Организация",
          accountPay: "Расчетный счет",
          purpPay: "Назначение платежа",
          statusPay: "Статус платежа",
          datePayFrom: "Период оплаты с",
          datePayTo: "по",
          sumPayMust: "Обязательный платеж",
          dateSaveReadings: "Дата снятия показаний",
          counter: "Счетчик",
          dateReading: "Показание на",
          current: "Текущее",
          difference: "Разница"
        },
        actTab: {
          title: "Погашение по акту",
          act: "Акт",
          actDate: "Дата:",
          actSum: "Сумма:",
          actType: "Тип:",
          note: "Примечание"
        },
        noteTab: {
          title: "Примечание"
        }
      },
      abcodeNotFound: "Лицевой счет не найден",
      info: {
        add: "Добавление записи",
        edit: "Изменение записи",
        del: "Возврат платежа"
      },
      actSwitcher: "F2 - Акт",
      buttons: {
        AddReadingOneZone: "Добавить показание",
        AddReadingTwoZone: "Добавить показания 2-зонного счетчика",
        AddReadingThreeZone: "Добавить показания 3-зонного счетчика",
        DeleteReading: "Удалить показание"
      },
      alert: {
        pointNumberCannotBeEmpty: "Номер точки учета не может быть пустым",
        modifyCurrentRecord: "Произвести изменение текущей записи?",
        makeRefund: "Произвести возврат платежа?",
        confirmMakeRefund:
          "Вы точно уверены в возврате этого платежа абоненту?",
        actExistsNoChangeAbcode:
          "К данному платежу привязан акт, смена лицевого счета невозможна"
      }
    },
    searchSubscribersForm: {
      modal: {
        title: "Поиск абонентов"
      },
      form: {
        fio: "ФИО",
        street: "Улица",
        house: "Дом",
        corpHouse: "Корпус дома",
        flat: "Квартира",
        ncount: "№ счетчика",
        nplomb: "№ пломбы",
        inn: "ИНН",
        eic: "EIC",
        abcode: "Лицевой счет",
        abcodeBegin: "Л/счет открыт",
        abcodeEnd: "закрыт",
        area: "Район",
        nact: "№ акта",
        fioPerson: "Фамилия физ. лица",
        nbid: "Номер заявки",
        naccount: "№ счета",
        ncontract: "№ договора",
        phone: "Телефон",
        nHouseAccount: "№ домового счетчика"
      },
      extendedSearch: "F2 Расширенный поиск",
      help: {
        message1:
          '<p>Условия поиска разбиты на две части: основные и дополнительные. Основные - ФИО, Улица, Дом, Квартира, Счетчик. Дополнительные (Номер акта, даты Создания и Закрытия лицевого счета, Район) отображаются, если установить флажок "Расширенный поиск".</p>',
        message2:
          "<p>Введенные значения запоминаются и автоматически появляются при повторном вызове формы.</p>",
        message3:
          '<p>Поиск ведется по совокупности всех указанных признаков. Дополнительные условия учитываются только при установленном флажке "Расширенный поиск".</p>',
        message4:
          '<p>Фамилию, № счетчика, № акта и лицевой счет можно указывать частично, если установить флажки "вхождение".</p>',
        message5:
          '<p>Поиск по этим полям также может осуществляться по маске: символ "?" означает один любой символ, символ "*" - ноль или больше символов.</p>',
        message6:
          '<p>(флажки вхождения - это частный случай маски, их установка аналогична приписыванию "*" в начале и в конце введенного значения).</p>'
      }
    },
    searchResultsForm: {
      modal: {
        title: "Результат выборки"
      },
      selectedRows: "Отобрано записей:"
    }
  }
};
